import { reqGET } from "../src/Utils";
import { getTokenInfo } from './UseToken';

import { api_crud_base, api_list_route } from '../src/components/WEBContent/PerfisMenus/Config';

import SidebarData from "./components/Sidebar/SideBarData";

import Main from './components/Main/Init'

import Agenda from './components/Agenda/Init'
import Evento from './components/Evento/Init'
import EventType from './components/Evento/EventType/Init'
import Forms from './components/Forms/Init'
import FormsType from './components/Forms/FormsType/Init'

import Calendar_Event from './components/Calendar/Event/Init'
import Calendar_Category from './components/Calendar/Category/Init'

import CalendarCopy from "./components/CalendarCopy/Event/Init"

import Content from './components/WEBContent/Content/Init'
import Content_News from './components/WEBContent/News/Init'
import Content_Press from './components/WEBContent/Press/Init'
import Content_Banner from './components/WEBContent/Banner/Init'
import Content_Gallery from './components/WEBContent/Gallery/Init'
import Content_Testemony from './components/WEBContent/Testemony/Init'
import Content_Category from './components/WEBContent/Category/Init'

import Content_Events from './components/WEBContent/Events/Init'

import Content_Corporate from './components/WEBContent/Corporate/Init'

import Tarefa from './components/Tarefa/Init'
import Intranet_Projetos from './components/Projetos/Init'
import Intranet_Suporte from './components/Suporte/Init'

import AppPerfil from './components/WEBContent/PerfisMenus/Init'
import EntityPerfil from './components/WEBContent/PerfisMenusEntidade/Init'

import Intranet_Entity_Dimension from './components/Intranet/Entity/Dimension/Init'
import Intranet_Entity_Function from './components/Intranet/Entity/Function/Init'
import Intranet_Entity_Relation from './components/Intranet/Entity/Relation/Init'
import Intranet_Entity_Sector from './components/Intranet/Entity/Sector/Init'

import Structure from './components/WEBContent/Structure/Init'
import Utilizador from './components/Entities/Utilizador/Init'
import Instrutor from './components/Entities/Instrutor/Init'
import Colaborador from './components/Entities/Colaborador/Init'
import Cliente from './components/Entities/Cliente/Init'
import Entidade from './components/Entities/Entidade/Init'
import Entidade02 from './components/Entities/Entidade02/Init'

import Company from './components/Entities/Company/Init'

import Empresa from './components/Entities/Empresa/Init'
import Empresa01 from './components/Entities/Empresa01/Init'
import Empresa02 from './components/Entities/Empresa02/Init'
import Entidade_externa from './components/Entities/Entidade_externa/Init'

import Intranet_Department from './components/Intranet/Department/Init'
import Intranet_Groups from './components/Intranet/Groups/Init'

import Intranet_Quality_DocumentType from './components/Intranet/Quality/DocumentType/Init'
import Intranet_Quality_RetentionTime from './components/Intranet/Quality/RetentionTime/Init'
import Intranet_Quality_StorageType from './components/Intranet/Quality/StorageType/Init'
import Intranet_Quality_Document from './components/Intranet/Quality/Document/Init'
import Intranet_Quality_DocumentObsolete from './components/Intranet/Quality/DocumentObsolete/Init'
import Intranet_Quality_DocumentDeleted from './components/Intranet/Quality/DocumentDeleted/Init'
import Intranet_Quality_OccurrenceType from './components/Intranet/Quality/OccurrenceType/Init'
import Intranet_Quality_OccurrenceOrigin from './components/Intranet/Quality/OccurrenceOrigin/Init'
import Intranet_Quality_OccurrenceState from './components/Intranet/Quality/OccurrenceState/Init'
import Intranet_Quality_Occurrence from './components/Intranet/Quality/Occurrence/Init'
import Intranet_Quality_Strategy from './components/Intranet/Quality/Strategy/Init'
import Intranet_Quality_StrategyBetsRisks from './components/Intranet/Quality/StrategyBetsRisks/Init'
import Intranet_Quality_MonitoringIndicators from './components/Intranet/Quality/MonitoringIndicators/Init'
import Intranet_Quality_EPI from './components/Intranet/Quality/EPI/Init'

import Intranet_Quality_Formation from './components/Intranet/Quality/Formation/Init'
import Intranet_Quality_SupplierEvaluation from './components/Intranet/Quality/SupplierEvaluation/Init'
import Intranet_Quality_SupplierEvaluationType from './components/Intranet/Quality/SupplierEvaluationType/Init'
import Intranet_Quality_SupplierQualityType from './components/Intranet/Quality/SupplierQualityType/Init'
import Intranet_Quality_SupplyQualityType from './components/Intranet/Quality/SupplyQualityType/Init'
import Intranet_Quality_SupplyType from './components/Intranet/Quality/SupplyType/Init'
import Intranet_Quality_FormationClassificationType from './components/Intranet/Quality/FormationClassificationType/Init'
import Intranet_Quality_FormationStateType from './components/Intranet/Quality/FormationStateType/Init'
import Intranet_Quality_EPI_Type from './components/Intranet/Quality/EPI_Type/Init'

import Intranet_CRM_Opportunity from './components/Intranet/CRM/Opportunity/Init'
import Intranet_CRM_StageType from './components/Intranet/CRM/StageType/Init'
import Intranet_CRM_ComType from './components/Intranet/CRM/ComType/Init'

import Intranet_Maintenance_ActiveType from './components/Intranet/Maintenance/ActiveType/Init'
import Intranet_Maintenance_ActiveState from './components/Intranet/Maintenance/ActiveState/Init'
import Intranet_Maintenance_Active from './components/Intranet/Maintenance/Active/Init'
import Intranet_Maintenance_RepairType from './components/Intranet/Maintenance/RepairType/Init'
import Intranet_Maintenance_Repair from './components/Intranet/Maintenance/Repair/Init'
import Intranet_Maintenance_Orders from './components/Intranet/Maintenance/Maintenance_Orders/Init'
import Intranet_Maintenance_Planeamento from './components/Intranet/Maintenance/Planeamento/Init'
import Intranet_Maintenance_Intervention from './components/Intranet/Maintenance/Intervention/Init'
import Intranet_Maintenance_Periodicity from './components/Intranet/Maintenance/Periodicity/Init'
import Intranet_Maintenance_Priority from './components/Intranet/Maintenance/Priority/Init'
import Intranet_Maintenance_EnergyType from './components/Intranet/Maintenance/EnergyType/Init'
import Intranet_Maintenance_Cost from './components/Intranet/Maintenance/Maintenance_Cost/Init'
import Intranet_Maintenance_Energy from './components/Intranet/Maintenance/Energy/Init'

import Intranet_Geral_License from './components/Intranet/Geral/License/Init'
import Intranet_Quality_License from './components/Intranet/Quality/License/Init'
import Intranet_Maintenance_License from './components/Intranet/Maintenance/License/Init'
import Intranet_CRM_License from './components/Intranet/CRM/License/Init'

export default function UseSidebar() {

  let sidebar_init = SidebarData({
    rotas: {
      Main: Main,

      Tarefa: Tarefa,
      Intranet_Suporte: Intranet_Suporte,
      Intranet_Projetos: Intranet_Projetos,

      Agenda: Agenda,
      Evento: Evento,
      EventType: EventType,
      Forms: Forms,
      FormsType: FormsType, 

      Calendar_Event: Calendar_Event,
      Calendar_Category: Calendar_Category,
      CalendarCopy: CalendarCopy,

      Content: Content,
      Content_News: Content_News,
      Content_Press: Content_Press,
      Content_Banner: Content_Banner,
      Content_Gallery: Content_Gallery,
      Content_Testemony: Content_Testemony,
      Content_Category: Content_Category,

      Content_Events: Content_Events,

      Content_Corporate: Content_Corporate,

      Entidade: Entidade,
      Entidade_externa: Entidade_externa,

      Instrutor: Instrutor,
      Colaborador: Colaborador,

      Company: Company,
      Empresa: Empresa,
      Empresa01: Empresa01,
      Empresa02: Empresa02,
      Entidade02: Entidade02,

      Utilizador: Utilizador,
      Cliente: Cliente,

      AppPerfil: AppPerfil,
      EntityPerfil: EntityPerfil,
      Intranet_Entity_Dimension: Intranet_Entity_Dimension,
      Intranet_Entity_Function: Intranet_Entity_Function,
      Intranet_Entity_Relation: Intranet_Entity_Relation,
      Intranet_Entity_Sector: Intranet_Entity_Sector,

      Intranet_Department: Intranet_Department,
      Intranet_Groups: Intranet_Groups,

      Intranet_Quality_Document: Intranet_Quality_Document,
      Intranet_Quality_DocumentObsolete: Intranet_Quality_DocumentObsolete,
      Intranet_Quality_DocumentDeleted: Intranet_Quality_DocumentDeleted,
      Intranet_Quality_DocumentType: Intranet_Quality_DocumentType,
      Intranet_Quality_RetentionTime: Intranet_Quality_RetentionTime,
      Intranet_Quality_StorageType: Intranet_Quality_StorageType,

      Intranet_Quality_Occurrence: Intranet_Quality_Occurrence,
      Intranet_Quality_OccurrenceType: Intranet_Quality_OccurrenceType,
      Intranet_Quality_OccurrenceOrigin: Intranet_Quality_OccurrenceOrigin,
      Intranet_Quality_OccurrenceState: Intranet_Quality_OccurrenceState,
      Intranet_Quality_Strategy: Intranet_Quality_Strategy,
      Intranet_Quality_StrategyBetsRisks: Intranet_Quality_StrategyBetsRisks,
      Intranet_Quality_MonitoringIndicators: Intranet_Quality_MonitoringIndicators,
      Intranet_Quality_EPI: Intranet_Quality_EPI,

      Intranet_Quality_Formation: Intranet_Quality_Formation,
      Intranet_Quality_SupplierEvaluation: Intranet_Quality_SupplierEvaluation,
      Intranet_Quality_SupplierEvaluationType: Intranet_Quality_SupplierEvaluationType,
      Intranet_Quality_SupplierQualityType: Intranet_Quality_SupplierQualityType,
      Intranet_Quality_SupplyQualityType: Intranet_Quality_SupplyQualityType,
      Intranet_Quality_SupplyType: Intranet_Quality_SupplyType,
      Intranet_Quality_FormationClassificationType: Intranet_Quality_FormationClassificationType,
      Intranet_Quality_FormationStateType: Intranet_Quality_FormationStateType,
      Intranet_Quality_EPI_Type: Intranet_Quality_EPI_Type,

      Intranet_CRM_Opportunity: Intranet_CRM_Opportunity,
      Intranet_CRM_StageType: Intranet_CRM_StageType,
      Intranet_CRM_ComType: Intranet_CRM_ComType,

      Intranet_Maintenance_Active: Intranet_Maintenance_Active,
      Intranet_Maintenance_Repair: Intranet_Maintenance_Repair,
      Intranet_Maintenance_ActiveType: Intranet_Maintenance_ActiveType,
      Intranet_Maintenance_ActiveState: Intranet_Maintenance_ActiveState,
      Intranet_Maintenance_RepairType: Intranet_Maintenance_RepairType,
      Intranet_Maintenance_Orders: Intranet_Maintenance_Orders,
      Intranet_Maintenance_Planeamento: Intranet_Maintenance_Planeamento,
      Intranet_Maintenance_Periodicity: Intranet_Maintenance_Periodicity,
      Intranet_Maintenance_Intervention: Intranet_Maintenance_Intervention,
      Intranet_Maintenance_Priority: Intranet_Maintenance_Priority,
      Intranet_Maintenance_EnergyType: Intranet_Maintenance_EnergyType,
      Intranet_Maintenance_Cost: Intranet_Maintenance_Cost,
      Intranet_Maintenance_Energy: Intranet_Maintenance_Energy,

      Intranet_Geral_License: Intranet_Geral_License,
      Intranet_Quality_License: Intranet_Quality_License,
      Intranet_Maintenance_License: Intranet_Maintenance_License,
      Intranet_CRM_License: Intranet_CRM_License,

      Structure: Structure
    }
  })

  const getSidebar = async (profile, isEdit = false) => {

    /*
    let sidebar_init = SidebarData({
      rotas: {
        Main: Main,

        Tarefa: Tarefa,  
        Intranet_Suporte: Intranet_Suporte,
        Intranet_Projetos: Intranet_Projetos,        

        Calendar_Event: Calendar_Event,
        Calendar_Category: Calendar_Category,
        CalendarCopy: CalendarCopy,

        Content: Content,
        Content_News: Content_News,
        Content_Press: Content_Press,
        Content_Banner: Content_Banner,
        Content_Gallery: Content_Gallery,
        Content_Testemony: Content_Testemony,
        Content_Category: Content_Category,

        Content_Events: Content_Events,
       
        Entidade: Entidade,
        Entidade_externa: Entidade_externa,            

        Instrutor: Instrutor,
        Colaborador: Colaborador,             
        
        Company: Company,
        Empresa: Empresa,
        Empresa01: Empresa01,
        Empresa02: Empresa02, 
        Entidade02: Entidade02,

        Utilizador: Utilizador,
        Cliente: Cliente,  

        AppPerfil: AppPerfil,
        EntityPerfil: EntityPerfil,       
         
        Intranet_Department: Intranet_Department,
        Intranet_Groups: Intranet_Groups,

        Structure: Structure
      }
    })
      */

    let companycodeLS = getTokenInfo().companycode
    //console.log(companycodeLS)

    if (companycodeLS === null || profile === null) {
      return sidebar_init
    }
    else {

      let result = await reqGET(api_list_route(companycodeLS))
        .then(res => {

          let profiles_list = res.data.filter(item => item.name === profile)

          let update_sidebar = (sidebar_original, sidebar_db) => {

            sidebar_original.forEach(element => {

              let tmp = sidebar_db.filter(e => e.id === element.id)

              if (tmp.length > 0) {

                /*
                element.title  =   element[0].title
                element.path   =   element[0].path
                element.icon   =   element[0].icon
                element.icon_b =   element[0].icon_b
                element.cName  =   element[0].cName 
                */

                element.allow = tmp[0].allow
                element.create = element.create !== undefined ? (tmp[0].create !== undefined ? tmp[0].create : false) : undefined
                element.edit = element.edit !== undefined ? (tmp[0].edit !== undefined ? tmp[0].edit : false) : undefined
                element.view = element.view !== undefined ? (tmp[0].view !== undefined ? tmp[0].view : false) : undefined
                element.remove = element.remove !== undefined ? (tmp[0].remove !== undefined ? tmp[0].remove : false) : undefined
                element.dash = element.dash !== undefined ? (tmp[0].dash !== undefined ? tmp[0].dash : false) : undefined
                element.admin = element.admin !== undefined ? (tmp[0].admin !== undefined ? tmp[0].admin : false) : undefined

                element.identificacao = element.identificacao !== undefined ? (tmp[0].identificacao !== undefined ? tmp[0].identificacao : false) : undefined
                element.naturalidade = element.naturalidade !== undefined ? (tmp[0].naturalidade !== undefined ? tmp[0].naturalidade : false) : undefined
                element.interlocutores = element.interlocutores !== undefined ? (tmp[0].interlocutores !== undefined ? tmp[0].interlocutores : false) : undefined
                element.fiscal = element.fiscal !== undefined ? (tmp[0].fiscal !== undefined ? tmp[0].fiscal : false) : undefined
                element.contrato = element.contrato !== undefined ? (tmp[0].contrato !== undefined ? tmp[0].contrato : false) : undefined
                element.associacao = element.associacao !== undefined ? (tmp[0].associacao !== undefined ? tmp[0].associacao : false) : undefined
                element.funcoes = element.funcoes !== undefined ? (tmp[0].funcoes !== undefined ? tmp[0].funcoes : false) : undefined
                element.configuracoes = element.configuracoes !== undefined ? (tmp[0].configuracoes !== undefined ? tmp[0].configuracoes : false) : undefined

                update_sidebar(element.submenu, tmp[0].submenu)
              }


            })
            return sidebar_original
          }

          if (isEdit === true) {

            return update_sidebar(sidebar_init, profiles_list[0].permissions.menu)

          } else {

            return profiles_list.length > 0 ? profiles_list[0].permissions.menu : [] // sidebar_init

          }

        })

      return result
    }
  }

  const getSidebarEntity = async (profile, isEdit = false) => {

    /*
    let sidebar_init = SidebarData({
      rotas: {
        Main: Main,

        Tarefa: Tarefa,  
        Intranet_Suporte: Intranet_Suporte,
        Intranet_Projetos: Intranet_Projetos,        

        Calendar_Event: Calendar_Event,
        Calendar_Category: Calendar_Category,
        CalendarCopy: CalendarCopy,

        Content: Content,
        Content_News: Content_News,
        Content_Press: Content_Press,
        Content_Banner: Content_Banner,
        Content_Gallery: Content_Gallery,
        Content_Testemony: Content_Testemony,
        Content_Category: Content_Category,

        Content_Events: Content_Events,
       
        Entidade: Entidade,
        Entidade_externa: Entidade_externa,            

        Instrutor: Instrutor,
        Colaborador: Colaborador,             
        
        Company: Company,
        Empresa: Empresa,
        Empresa01: Empresa01,
        Empresa02: Empresa02, 
        Entidade02: Entidade02,

        Utilizador: Utilizador,
        Cliente: Cliente,  

        AppPerfil: AppPerfil,
        EntityPerfil: EntityPerfil,       
         
        Intranet_Department: Intranet_Department,
        Intranet_Groups: Intranet_Groups,

        Structure: Structure
      }
    })
    */

    let companycodeLS = getTokenInfo().companycode
    //console.log(companycodeLS)

    if (companycodeLS === null || profile === null) {
      return sidebar_init
    }
    else {

      let result = await reqGET(`${api_crud_base}/entities/profiles/${getTokenInfo().companycode}`)
        .then(res => {

          let profiles_list = res.data.filter(item => item.name === profile)

          let update_sidebar = (sidebar_original, sidebar_db) => {

            sidebar_original.forEach(element => {

              let tmp = sidebar_db.filter(e => e.id === element.id)

              if (tmp.length > 0) {

                /*
                element.title  =   element[0].title
                element.path   =   element[0].path
                element.icon   =   element[0].icon
                element.icon_b =   element[0].icon_b
                element.cName  =   element[0].cName 
                */
                element.allow = tmp[0].allow
                element.create = tmp[0].create
                element.edit = tmp[0].edit
                element.view = tmp[0].view
                element.remove = tmp[0].remove
                element.dash = tmp[0].dash
                element.admin = tmp[0].admin

                update_sidebar(element.submenu, tmp[0].submenu)
              }


            })
            return sidebar_original
          }

          if (isEdit === true) {

            return update_sidebar(sidebar_init, profiles_list[0].settings.menu)

          } else {

            return profiles_list.length > 0 ? profiles_list[0].settings.menu : [] // sidebar_init

          }

        })

      return result
    }
  }

  return {
    getSidebar,
    getSidebarEntity,
  }
}